// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.other-tests-tab {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.other-tests-section {
  margin-bottom: 0;
}

.other-tests-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  min-width: 0;
  color: #fff;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
}

.other-tests-toggle input {
  margin: 0;
}

.other-tests-title {
  font-size: 15px;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
  color: #fff;
}

.other-tests-section-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.other-tests-empty-state {
  padding: 12px 14px;
  border: 1px dashed #cfdae5;
  border-radius: 4px;
  background: #f7fbff;
  color: #53657a;
  font-size: 12px;
}

.other-tests-note-row {
  display: flex;
  gap: 8px;
  align-items: start;
}

.other-tests-note-row > label {
  flex: 0 0 auto;
  margin: 6px 0 0;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
}

.other-tests-inline-remove {
  flex: 0 0 auto;
  align-self: start;
  margin-top: 2px;
}

.other-tests-notes-input {
  flex: 1 1 auto;
  min-width: 0;
  width: 100% !important;
  max-width: none !important;
  min-height: 82px;
  resize: vertical;
  line-height: 1.4;
}

@media (max-width: 960px) {
  .other-tests-note-row {
    flex-wrap: wrap;
  }

  .other-tests-note-row > label {
    margin-top: 0;
  }

  .other-tests-notes-input {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-details/tabs/slurry-other-tab/slurry-other-tab.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".other-tests-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.other-tests-section {\n  margin-bottom: 0;\n}\n\n.other-tests-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  min-width: 0;\n  color: #fff;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n}\n\n.other-tests-toggle input {\n  margin: 0;\n}\n\n.other-tests-title {\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n  color: #fff;\n}\n\n.other-tests-section-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.other-tests-empty-state {\n  padding: 12px 14px;\n  border: 1px dashed #cfdae5;\n  border-radius: 4px;\n  background: #f7fbff;\n  color: #53657a;\n  font-size: 12px;\n}\n\n.other-tests-note-row {\n  display: flex;\n  gap: 8px;\n  align-items: start;\n}\n\n.other-tests-note-row > label {\n  flex: 0 0 auto;\n  margin: 6px 0 0;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n}\n\n.other-tests-inline-remove {\n  flex: 0 0 auto;\n  align-self: start;\n  margin-top: 2px;\n}\n\n.other-tests-notes-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100% !important;\n  max-width: none !important;\n  min-height: 82px;\n  resize: vertical;\n  line-height: 1.4;\n}\n\n@media (max-width: 960px) {\n  .other-tests-note-row {\n    flex-wrap: wrap;\n  }\n\n  .other-tests-note-row > label {\n    margin-top: 0;\n  }\n\n  .other-tests-notes-input {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
